import React, { useState, useEffect, useMemo, createContext } from 'react'
import ReactTooltip from 'react-tooltip'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import LoginMenu from '../auth/loginmenu'
import ScopeSelector from './scope'
import SideNav from './sidenav'
import Main from '../main'

import EventTemplate from '../../components/alert/eventtemplate';
import { transitions, positions, Provider as AlertProvider } from 'react-alert'

const eventAlertOptions = {
	position: positions.BOTTOM_CENTER,
	timeout: 5000,
	offset: '10px',
	transition: transitions.FADE
}


export const eventAlertContext = createContext();

const smallMarginTop = { marginTop: "calc(6rem + 1px)" }

const pageBackgroundImage = [
	'linear-gradient( transparent 15px, var(--main-bg-color) 70px)',
	'linear-gradient( rgba(var(--page-bg-rgb), 0.3) 1.2px, transparent 1.2px)',
	'linear-gradient(90deg, rgba(var(--page-bg-rgb), 0.3) 1.2px, transparent 1.2px)',
	'linear-gradient( rgba(var(--page-bg-rgb), 0.15) 0.6px, transparent 0.6px)',
	'linear-gradient(90deg, rgba(var(--page-bg-rgb), 0.15) 0.6px, var(--main-bg-color) 0.6px)'
].join(', ')

const pageBackgroundStyle = {
	backgroundColor: 'var(--main-bg-color)',
	backgroundImage: pageBackgroundImage,
	backgroundSize: '100% 100%, 40px 40px, 40px 40px, 8px 8px, 8px 8px',
	backgroundPosition: '0px 0px, -1.2px -1.2px, -1.2px -1.2px, -0.6px -0.6px, -0.6px -0.6px',
	transition: "background-color 1s ease-in-out"
}

const Layout = ({ context, ...props }) => {
	const [isSmall, setIsSmall] = useState(window.matchMedia('(max-width: 575px)').matches);
	const [background, setPageBackground] = useState('169, 169, 169')
	const dispatch = context.dispatch
	useEffect(() => {
		dispatch({ type: "set", payload: { pageBackground: setPageBackground } })

		return () => {
			dispatch({ type: "set", payload: { pageBackground: null } })
		}
	}, [dispatch])

	useEffect(() => {
		const mediaMatch = window.matchMedia('(max-width: 575px)');
		const handler = e => setIsSmall(e.matches)
		mediaMatch.addEventListener("change", handler);
		return () => mediaMatch.removeEventListener("change", handler)
	}, [])

	useEffect(() => {
		if (window.innerWidth > 1400) {//auto expand menu on load
			document.getElementById("menuButtonExpandCollapse").click();
		}
	}, [])

	const smMarginT = isSmall && context.scope.current ? smallMarginTop : undefined
	const smMinH = isSmall && context.scope.current ? { minHeight: "97px" } : undefined

	const contentPageStyle = useMemo(() => ({
		...smMarginT,
		...pageBackgroundStyle
	}), [smMarginT])

	return (
		<div className="wrapper" style={{
			"--main-bg-rgb": '244, 246, 249',
			"--main-bg-color": 'rgba(var(--main-bg-rgb), 1)',
			"--page-bg-rgb": background,
			"--page-bg-color": 'rgba(var(--page-bg-rgb), 1)'
		}}>
			<nav className="main-header navbar navbar-expand navbar-light" style={{
				borderColor: 'var(--page-bg-color)',
				backgroundColor: 'var(--page-bg-color)',
				backgroundImage: "radial-gradient(110% 100px at left bottom, rgba(var(--main-bg-rgb), 0.40), rgba(var(--main-bg-rgb), 0.70)",
				transition: "background-color 1s ease-in-out, border-color 1s ease-in-out"
			}}>
				<div className="container-fluid">

					<div className="row mx-0" style={{ width: "100%" }}>
						<div className="col order-first">
							<button id="menuButtonExpandCollapse" type="button" data-widget="pushmenu" className="mr-auto btn btn-outline-default">
								<FontAwesomeIcon icon="bars" />
							</button>

						</div>

						<div className="col order-3 d-flex" style={{ maxWidth: "110px" }}>
							<button type="button" onClick={() => context.dispatch({ type: "refresh-data", payload: true })} className="btn ml-auto" data-tip={context.lastRefresh || "click para refrescar"}>
								<i id="spinrefreshbtn" className="fas fa-sync" />
								<FontAwesomeIcon icon="sync" {...(context.refreshing && { spin: true })} />
							</button>
							<LoginMenu dispatch={context.dispatch} />
						</div>

						<div className="col-12 order-last col-sm-auto order-sm-2">
							<ScopeSelector scope={context.scope} dispatch={context.dispatch} />
						</div>

					</div>
				</div>
				<ReactTooltip effect="solid" place="bottom" multiline className="py-1 px-2" />

			</nav>
			<SideNav smMarginT={smMarginT} smMinH={smMinH} pages={context.page} menu={context.menu} tipo={context.scope.current?.tipo} empresa={context.scope.current?.empresa} />
			<div className="content-wrapper d-flex flex-column" style={contentPageStyle}>
				<AlertProvider template={EventTemplate} {...eventAlertOptions} containerStyle={{ marginTop: isSmall ? "100px" : "60px" }} context={eventAlertContext} >
					<Main {...props} />
				</AlertProvider>
			</div>
		</div>
	)
}

export default Layout;

